__webpack_require__.p = "/News-App/";